module.exports = __webpack_public_path__ + "static/Peyote-logo-7eb422fac2a7d2a36c4cadcfd4cdf181.svg";